<script>
    export let text;
    let isoff = true;

    setTimeout(() => (isoff = false), 2000);

</script>

<div class="screen glitch">
    <div class="clock" class:is-off={isoff}>
        <span class="text" data-text={text}>{text}</span>
    </div>
    <div class="figure" />
    <div class="figure-mask" />
</div>

<style>
    *,
    *:before,
    *:after {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        box-sizing: border-box;
        user-select: none;
    }

    .screen {
        --bg-color: #111;
        --text-color: #fff;
        --color-c1: red;
        --color-c2: blue;
    }
    .screen {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 300px;
        overflow: hidden;
    }
    .figure {
        display: block;
        position: absolute;
        z-index: 1;
        width: 0;
        height: 0;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        border-top: 200px solid;
        border-top-color: var(--ion-text-color);
        border-right: 100px solid transparent;
        border-left: 100px solid transparent;
        border-bottom: 0 solid transparent;
    }
    .figure:before {
        display: block;
        content: "";
        position: absolute;
        z-index: 99;
        width: 0;
        height: 0;
        top: -194px;
        left: -90px;
        margin: auto;
        border-top: 180px solid;
        border-top-color: var(--ion-background-color);
        border-right: 90px solid transparent;
        border-left: 90px solid transparent;
        border-bottom: 0 solid transparent;
    }
    .figure-mask {
        display: block;
        position: absolute;
        z-index: 99;
        width: 0;
        height: 0;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        border-top: 200px solid transparent;
        border-right: 0px solid;
        border-right-color: var(--ion-background-color);
        border-left: 0px solid;
        border-left-color: var(--ion-background-color);
        border-bottom: 0 solid transparent;
    }
    .clock {
        display: block;
        position: absolute;
        z-index: 9;
        width: 100%;
        height: 128px;
        text-align: center;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        cursor: default;
    }
    .clock span {
        display: block;
        position: relative;
        font-size: 4rem;
        letter-spacing: 4px;
        line-height: 1;
    }
    .clock.is-off {
        animation: is-off 2s linear infinite !important;
    }
    .glitch .figure,
    .glitch .figure-mask {
        transform: skewX(0deg) scaleY(1);
        animation: tr-bag 4s linear infinite;
    }
    .glitch .clock {
        transform: skewX(0deg) scaleY(1);
        animation: clock-bag 4s linear infinite;
    }
    .glitch .clock span:before,
    .glitch .clock span:after {
        display: block;
        content: attr(data-text);
        position: absolute;
        top: 0;
        color: var(--ion-text-color);
        background: var(--ion-background-color);
        overflow: hidden;
        width: 100%;
        height: 128px;
        clip: rect(0, 900px, 0, 0);
    }
    .glitch .clock span:before {
        left: -2px;
        text-shadow: 2px 0 var(--color-c2);
        animation: c2 1s infinite linear alternate-reverse;
    }
    .glitch .clock span:after {
        left: 3px;
        text-shadow: -2px 0 var(--color-c1);
        animation: c1 2s infinite linear alternate-reverse;
    }

    @keyframes is-off {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 1;
        }
        56% {
            opacity: 0;
        }
        57% {
            opacity: 0;
        }
        58% {
            opacity: 1;
        }
        71% {
            transform: scaleY(1) skewX(0deg);
        }
        72% {
            transform: scaleY(3) skewX(-60deg);
        }
        73% {
            transform: scaleY(1) skewX(0deg);
        }
        80% {
            opacity: 1;
        }
        81% {
            opacity: 0;
        }
        84% {
            opacity: 0;
        }
        85% {
            opacity: 1;
        }
        91% {
            transform: scaleX(1) scaleY(1) skewX(0deg);
            color: var(--ion-text-color);
        }
        92% {
            transform: scaleX(1.5) scaleY(0.2) skewX(80deg);
            color: #008000;
        }
        93% {
            transform: scaleX(1) scaleY(1) skewX(0deg);
            color: var(--ion-text-color);
        }
    }
    @keyframes c1 {
        0% {
            clip: rect(12px, 9999px, 27px, 0);
        }
        5% {
            clip: rect(32px, 9999px, 21px, 0);
        }
        10% {
            clip: rect(55px, 9999px, 57px, 0);
        }
        15.000000000000002% {
            clip: rect(16px, 9999px, 72px, 0);
        }
        20% {
            clip: rect(31px, 9999px, 46px, 0);
        }
        25% {
            clip: rect(11px, 9999px, 26px, 0);
        }
        30.000000000000004% {
            clip: rect(45px, 9999px, 24px, 0);
        }
        35.00000000000001% {
            clip: rect(79px, 9999px, 50px, 0);
        }
        40% {
            clip: rect(39px, 9999px, 59px, 0);
        }
        45% {
            clip: rect(36px, 9999px, 90px, 0);
        }
        50% {
            clip: rect(88px, 9999px, 19px, 0);
        }
        55% {
            clip: rect(41px, 9999px, 12px, 0);
        }
        60.00000000000001% {
            clip: rect(54px, 9999px, 51px, 0);
        }
        65% {
            clip: rect(53px, 9999px, 22px, 0);
        }
        70.00000000000001% {
            clip: rect(64px, 9999px, 98px, 0);
        }
        75% {
            clip: rect(42px, 9999px, 41px, 0);
        }
        80% {
            clip: rect(18px, 9999px, 37px, 0);
        }
        85% {
            clip: rect(86px, 9999px, 7px, 0);
        }
        90% {
            clip: rect(90px, 9999px, 11px, 0);
        }
        95% {
            clip: rect(8px, 9999px, 29px, 0);
        }
        100% {
            clip: rect(37px, 9999px, 50px, 0);
        }
    }
    @keyframes c2 {
        0% {
            clip: rect(19px, 9999px, 65px, 0);
        }
        5% {
            clip: rect(41px, 9999px, 59px, 0);
        }
        10% {
            clip: rect(4px, 9999px, 25px, 0);
        }
        15.000000000000002% {
            clip: rect(43px, 9999px, 22px, 0);
        }
        20% {
            clip: rect(96px, 9999px, 19px, 0);
        }
        25% {
            clip: rect(20px, 9999px, 25px, 0);
        }
        30.000000000000004% {
            clip: rect(62px, 9999px, 46px, 0);
        }
        35.00000000000001% {
            clip: rect(24px, 9999px, 84px, 0);
        }
        40% {
            clip: rect(71px, 9999px, 25px, 0);
        }
        45% {
            clip: rect(100px, 9999px, 72px, 0);
        }
        50% {
            clip: rect(6px, 9999px, 2px, 0);
        }
        55% {
            clip: rect(92px, 9999px, 77px, 0);
        }
        60.00000000000001% {
            clip: rect(30px, 9999px, 92px, 0);
        }
        65% {
            clip: rect(48px, 9999px, 11px, 0);
        }
        70.00000000000001% {
            clip: rect(63px, 9999px, 21px, 0);
        }
        75% {
            clip: rect(98px, 9999px, 54px, 0);
        }
        80% {
            clip: rect(70px, 9999px, 13px, 0);
        }
        85% {
            clip: rect(69px, 9999px, 63px, 0);
        }
        90% {
            clip: rect(55px, 9999px, 8px, 0);
        }
        95% {
            clip: rect(44px, 9999px, 15px, 0);
        }
        100% {
            clip: rect(89px, 9999px, 37px, 0);
        }
        23% {
            transform: scaleX(0.8);
        }
    }
    @keyframes clock-bag {
        0% {
            transform: translate(5px, 2px);
        }
        2% {
            transform: translate(5px, 4px);
        }
        4% {
            transform: translate(5px, 3px);
        }
        6% {
            transform: translate(5px, 2px);
        }
        8% {
            transform: translate(2px, 2px);
        }
        10% {
            transform: translate(2px, 2px);
        }
        12% {
            transform: translate(1px, 4px);
        }
        14.000000000000002% {
            transform: translate(1px, 4px);
        }
        16% {
            transform: translate(3px, 4px);
        }
        18% {
            transform: translate(2px, 4px);
        }
        20% {
            transform: translate(2px, 2px);
        }
        22% {
            transform: translate(5px, 4px);
        }
        24% {
            transform: translate(3px, 2px);
        }
        26% {
            transform: translate(1px, 3px);
        }
        28.000000000000004% {
            transform: translate(5px, 4px);
        }
        30% {
            transform: translate(5px, 3px);
        }
        32% {
            transform: translate(5px, 2px);
        }
        34% {
            transform: translate(2px, 5px);
        }
        36% {
            transform: translate(3px, 1px);
        }
        38% {
            transform: translate(2px, 3px);
        }
        40% {
            transform: translate(5px, 5px);
        }
        42% {
            transform: translate(1px, 3px);
        }
        44% {
            transform: translate(3px, 2px);
        }
        46.00000000000001% {
            transform: translate(1px, 1px);
        }
        48% {
            transform: translate(4px, 2px);
        }
        50% {
            transform: translate(3px, 4px);
        }
        52% {
            transform: translate(4px, 4px);
        }
        54% {
            transform: translate(5px, 1px);
        }
        56.00000000000001% {
            transform: translate(2px, 1px);
        }
        58% {
            transform: translate(5px, 2px);
        }
        60% {
            transform: translate(5px, 1px);
        }
        62% {
            transform: translate(2px, 1px);
        }
        64% {
            transform: translate(2px, 4px);
        }
        66% {
            transform: translate(4px, 4px);
        }
        68% {
            transform: translate(1px, 4px);
        }
        70.00000000000001% {
            transform: translate(1px, 4px);
        }
        72% {
            transform: translate(4px, 1px);
        }
        74% {
            transform: translate(3px, 2px);
        }
        76% {
            transform: translate(5px, 3px);
        }
        78% {
            transform: translate(1px, 3px);
        }
        80% {
            transform: translate(5px, 1px);
        }
        82.00000000000001% {
            transform: translate(2px, 5px);
        }
        84% {
            transform: translate(1px, 1px);
        }
        86% {
            transform: translate(4px, 4px);
        }
        88% {
            transform: translate(1px, 5px);
        }
        90% {
            transform: translate(1px, 2px);
        }
        92.00000000000001% {
            transform: translate(2px, 1px);
        }
        94% {
            transform: translate(5px, 1px);
        }
        96% {
            transform: translate(2px, 4px);
        }
        98% {
            transform: translate(4px, 3px);
        }
        100% {
            transform: translate(5px, 1px);
        }
        1% {
            transform: scaleY(1) skewX(0deg);
        }
        1.5% {
            transform: scaleY(3) skewX(-60deg);
        }
        2% {
            transform: scaleY(1) skewX(0deg);
        }
        51% {
            transform: scaleX(1) scaleY(1) skewX(0deg);
        }
        52% {
            transform: scaleX(1.5) scaleY(0.2) skewX(80deg);
        }
        53% {
            transform: scaleX(1) scaleY(1) skewX(0deg);
        }
    }
    @keyframes tr-bag {
        0% {
            transform: translate(1px, 2px);
        }
        2% {
            transform: translate(5px, 3px);
        }
        4% {
            transform: translate(5px, 1px);
        }
        6% {
            transform: translate(5px, 2px);
        }
        8% {
            transform: translate(1px, 5px);
        }
        10% {
            transform: translate(5px, 1px);
        }
        12% {
            transform: translate(3px, 5px);
        }
        14.000000000000002% {
            transform: translate(5px, 5px);
        }
        16% {
            transform: translate(2px, 3px);
        }
        18% {
            transform: translate(2px, 3px);
        }
        20% {
            transform: translate(5px, 5px);
        }
        22% {
            transform: translate(5px, 2px);
        }
        24% {
            transform: translate(2px, 4px);
        }
        26% {
            transform: translate(5px, 4px);
        }
        28.000000000000004% {
            transform: translate(4px, 2px);
        }
        30% {
            transform: translate(5px, 4px);
        }
        32% {
            transform: translate(2px, 3px);
        }
        34% {
            transform: translate(5px, 5px);
        }
        36% {
            transform: translate(5px, 3px);
        }
        38% {
            transform: translate(4px, 2px);
        }
        40% {
            transform: translate(4px, 1px);
        }
        42% {
            transform: translate(4px, 4px);
        }
        44% {
            transform: translate(1px, 1px);
        }
        46.00000000000001% {
            transform: translate(5px, 4px);
        }
        48% {
            transform: translate(4px, 1px);
        }
        50% {
            transform: translate(2px, 1px);
        }
        52% {
            transform: translate(4px, 3px);
        }
        54% {
            transform: translate(2px, 5px);
        }
        56.00000000000001% {
            transform: translate(2px, 1px);
        }
        58% {
            transform: translate(1px, 1px);
        }
        60% {
            transform: translate(2px, 3px);
        }
        62% {
            transform: translate(2px, 4px);
        }
        64% {
            transform: translate(5px, 1px);
        }
        66% {
            transform: translate(5px, 3px);
        }
        68% {
            transform: translate(2px, 4px);
        }
        70.00000000000001% {
            transform: translate(4px, 1px);
        }
        72% {
            transform: translate(4px, 4px);
        }
        74% {
            transform: translate(1px, 5px);
        }
        76% {
            transform: translate(4px, 5px);
        }
        78% {
            transform: translate(3px, 1px);
        }
        80% {
            transform: translate(4px, 2px);
        }
        82.00000000000001% {
            transform: translate(3px, 4px);
        }
        84% {
            transform: translate(3px, 1px);
        }
        86% {
            transform: translate(2px, 2px);
        }
        88% {
            transform: translate(5px, 4px);
        }
        90% {
            transform: translate(4px, 4px);
        }
        92.00000000000001% {
            transform: translate(2px, 1px);
        }
        94% {
            transform: translate(1px, 4px);
        }
        96% {
            transform: translate(1px, 4px);
        }
        98% {
            transform: translate(2px, 4px);
        }
        100% {
            transform: translate(2px, 4px);
        }
        1% {
            transform: scaleY(1) skewX(0deg);
        }
        1.5% {
            transform: scaleY(3) skewX(-60deg);
        }
        2% {
            transform: scaleY(1) skewX(0deg);
        }
        51% {
            transform: scaleX(1) scaleY(1) skewX(0deg);
        }
        52% {
            transform: scaleX(1.5) scaleY(0.2) skewX(80deg);
        }
        53% {
            transform: scaleX(1) scaleY(1) skewX(0deg);
        }
    }

</style>
